

/**Company component Images */
import ERP from "../img/Introduction/erp.png";
import CRM from "../img/Introduction/crm.png";
import BI from "../img/Introduction/bi.jpg";

import Cloud from "../img/Introduction/cloud.jpg";
import DI from "../img/Introduction/dataintegration.jpg";
import App from "../img/Introduction/webapps.png";



export const companyDetails = [
    {
        title: "Artificial Intelligence Solutions",
        image: BI,
        content: `Building AI solutions using LLMs (OpenAI, CoPilot, Gemini), Agentic AI systems and workflows. Perform research on AI and build algorithms, technology solutions using AI`,
    },
    {
        title: "CRM Solutions",
        image: CRM,
        content: `Understand business needs of the customer, evaluate and recommend suitable CRM solutions that brings the best value for the customer.`,
    },
    {
        title: "ERP Solutions",
        image: ERP,
        content: `Configuring / customizing ERP namely SAP, Oracle EBS, NetSuite (Cloud based ERP), PeopleSoft, JDE, MS Dynamics, Tally.ERP software systems to support customer specific business processes`,
    },


    {
        title: "Cloud Solutions",
        image: Cloud,
        content: ` Cloud Solutions: Assist with migrating on-premise applications
             into Cloud platforms namely AWS, Azure, Google Cloud (GCP). Strong experience
              in building strong data engineering solutions
             on these cloud platforms including multi-cloud strategy development`,
    },

    {
        title: "Data Integration",
        image: DI,
        content: `Data Integration: Integrate data across software applications
             using leading ETL tools such as Informatica, Dell Boomi, and our
              own data integration tool called TIPS.`,
    },

    {
        title: "Web/Mobile Apps",
        image: App,
        content: `Build custom web applications, mobile apps (Apple, Android) per your needs. Also, build or maintain your company websites with SEO (Search Engine Optimization) capabilities.`,
    },
];